import React from 'react';
import Svg from '../Svg';

const IconCloudRaining04 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.50941 4.01977C7.66126 2.20617 9.68905 1 12 1C14.714 1 17.0375 2.66263 18.0112 5.02345C20.8091 5.28134 23 7.63481 23 10.5C23 13.5376 20.5376 16 17.5 16H7C3.68629 16 1 13.3137 1 10C1 6.85147 3.42516 4.26936 6.50941 4.01977ZM12 3C10.2524 3 8.73567 3.996 7.98971 5.45596C7.81561 5.7967 7.46233 6.00822 7.07975 6.00078C7.05322 6.00026 7.02664 6 7 6C4.79086 6 3 7.79086 3 10C3 12.2091 4.79086 14 7 14H17.5C19.433 14 21 12.433 21 10.5C21 8.567 19.433 7 17.5 7C17.4461 7 17.3925 7.00122 17.3392 7.00361C16.8752 7.02449 16.4578 6.72305 16.3318 6.27594C15.7987 4.38471 14.0598 3 12 3ZM8 17.5C8.55228 17.5 9 17.9477 9 18.5V21C9 21.5523 8.55228 22 8 22C7.44772 22 7 21.5523 7 21V18.5C7 17.9477 7.44772 17.5 8 17.5ZM16 17.5C16.5523 17.5 17 17.9477 17 18.5V21C17 21.5523 16.5523 22 16 22C15.4477 22 15 21.5523 15 21V18.5C15 17.9477 15.4477 17.5 16 17.5ZM12 18.5C12.5523 18.5 13 18.9477 13 19.5V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V19.5C11 18.9477 11.4477 18.5 12 18.5Z"
    />
  </Svg>
);

export default IconCloudRaining04;
